import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=2c6b72f4&scoped=true&"
import script from "./Vision.vue?vue&type=script&lang=js&"
export * from "./Vision.vue?vue&type=script&lang=js&"
import style0 from "./Vision.vue?vue&type=style&index=0&id=2c6b72f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b72f4",
  null
  
)

export default component.exports